<template>
  <b-container id="maindiv">
    <section>
      <b-row>
        <div class="col-md-8">
          <h2>{{caption}}</h2>
        </div>
        <div class="col-md-4">
          <div v-if="loaded" class="toolbar">
            <b-button v-if="canreply" variant="primary" class="shadow-sm mt-2 ml-1 px-3" @click.prevent="doreply()">{{$lang('reply')}}</b-button>
            <b-button v-if="cansave" class="shadow-sm mt-2 ml-1 px-3" @click.prevent="dosave()">
              <b-spinner v-if="waitsave" small></b-spinner>
              <span>{{$lang('save')}}</span>
            </b-button>
            <b-button v-if="candelete" variant="danger" class="shadow-sm mt-2 ml-1 px-3" @click.prevent="dodelete()">
              {{$lang('delete')}}
            </b-button>
            <b-button v-if="cansend" variant="primary" class="shadow-sm mt-2 ml-1 px-3" @click.prevent="dosend()">
              <b-spinner v-if="waitsend" small></b-spinner>
              <span>{{$lang('send')}}</span>
            </b-button>
          </div>
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content">
        
        <div v-if="wait" class="text-center text-muted my-5">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{$lang('loading')}}</strong>
        </div>

        <b-alert v-if="error" show variant="danger" class="text-center text-muted my-2">
          {{error}}
        </b-alert>

        <b-alert v-if="finalmessage" show variant="success" class="text-center text-muted my-2">
          {{finalmessage}}
        </b-alert>
        
        <div v-if="loaded">
          <b-form-group v-if="doc.data.to">
            {{$lang('to')}}
            <b-form-input readonly v-model="doc.data.to"></b-form-input>
          </b-form-group>
          <b-form-group v-if="doc.data.from">
            {{$lang('from')}}
            <b-form-input readonly v-model="doc.data.from"></b-form-input>
          </b-form-group>
          <b-form-group>
            {{$lang('subj')}}
            <b-form-input :readonly="!cansave" v-model="doc.data.subj"></b-form-input>
          </b-form-group>
          <b-form-group>
            {{$lang('text')}}
            <mc-wysiwyg id="wysiwyged" :editable="cansave" v-model="doc.data.mess"/>
          </b-form-group>

          
          
          <ul class="list-unstyled mt-4">
            <li v-for="one in doc.data.files" :key="one.id" class="media" >
              <div v-if="one.filename">
                <a :href="'/api/GetMessageFile?fileid='+one.id">
                  <img :src="one.filepreview" class="mr-3 fileicon" :alt="one.filename">
                </a>
                <div class="media-body">
                  <a :href="'/api/GetMessageFile?fileid='+one.id">
                    <h5 class="mt-0 mb-1">{{one.filename}}</h5>
                  </a>
                  <h6 class="mt-0 mb-1">{{one.fileinfo}}</h6>
                  {{one.filedesc}}
                </div>
                <b-button v-if="cansave" @click.prevent='removeFile(one.id)'>
                  <i class="fa fa-trash-o"></i>
                </b-button> 
              </div>
            </li>
          </ul>

          <b-form-file v-if="cansave" multiple ref="file-input" @input="addFiles" :placeholder='$lang("hereFiles")' :browse-text='$lang("browse")'>
          </b-form-file>

        </div>
      </div>
    </section>

    <section>
    </section>

  </b-container>
  
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.openDocument();
  },
  data() {
    return {
      id: null,
      contextid: null,
      wait: true,
      waitsave: false,
      waitsend: false,
      error: null,
      finalmessage: null,
      loaded: null,
      caption: null,
      doc: { data: {}, actions:{}},
      newfileid: -1,
    };
  },
  watch: {
    $route() {
      if (this.id != this.$route.query.id){
        this.openDocument();
      }
    },
  },
  computed: {
    cansave: function (){return this.can('save');},
    canreply: function (){return this.can('reply');},
    candelete: function (){return this.can('delete');},
    cansend: function (){return this.can('send');},
  },
  methods: {
    async readFile(file) {
      let result_base64 = await new Promise((resolve) => {
        let fr = new FileReader();
        fr.onload = (e) => resolve(fr.result);
        fr.readAsDataURL(file);
      });
      return result_base64;
    },    
    async addFiles(file){
      file.forEach(i => this.addFile(i));
      this.$refs['file-input'].reset();
    },
    async addFile(i){
      if (i.size > 1024*1024*3){
        this.$bvToast.toast("File size is too big: "+i.name, {title: "Error", variant: "danger"});
      } else {
        let newItem = {id: this.getnewfileid(), filename: i.name, filepreview: '/dist/file2.png'};
        newItem.content = await this.readFile(i);
        this.doc.data.files.push(newItem);
      }
    },
    removeFile(oneid){
      this.doc.data.files = this.doc.data.files.filter(t=> t.id !== oneid)
    },
    getnewfileid(){
      this.newfileid--;
      return 'new'+this.newfileid;
    },
    can(action){
      if (this.doc.actions != null && this.doc.actions[action])
        return true;
      return false;
    },
    doreply(){
      this.$router.push({name:'mailItem', query: {id: -1, contextid: this.id}});
      this.openDocument();
    },
    dosave(){
      if (this.waitsave||this.waitsend) {
        return;
      }
      this.waitsave = true;
      let data2save = {id: this.id, contextid: this.contextid, data: this.doc.data, action:'save'};
      this.callsave(data2save);
    },
    dosend(){
      if (this.waitsave||this.waitsend) {
        return;
      }
      this.waitsend = true;
      let data2save = {id: this.id, contextid: this.contextid, data: this.doc.data, action:'send'};
      this.callsave(data2save, true);
    },
    dodelete(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to delete this message?')
          .then(value => {
            if (value === true) {
               let data2save = {id: this.id, contextid: this.contextid, action:'delete'};
               this.callsave(data2save);
            }
          })
    },
    callsave(data,showResult){
      axios.post('/api/SaveMessage', data) 
        .then(answ => {
          this.waitsave = false;
          this.waitsend = false;
          if (answ.data.close){
            this.loaded = false;
            this.finalmessage = answ.data.message;
          } else {
            this.id = answ.data.doc.data.id;
            this.doc = answ.data.doc;
            this.$router.replace({name:'mailItem', query: {id: this.id}});
            if (this.id != -1){
              this.caption = this.$lang('mail');
            };
            if (showResult)
              this.$bvToast.toast(answ.data.message, {title: "Success", variant: "success"}); 
          };
        })
        .catch(error => {
          this.waitsave = false;
          this.waitsend = false;
          let actionerror = error.message;
          if (error.response && error.response.data.message) {
             actionerror = error.response.data.message;
          }
          this.$bvToast.toast(actionerror, {title: "Error", variant: "danger"});
        });
    },
    openDocument() {
      this.error = null;
      this.finalmessage = null;
      this.wait = true;
      this.loaded = false;
      this.doc = { data: {}, actions:{}};
      this.id = this.$route.query.id;
      this.caption = this.$lang('mail');
      this.contextid = this.$route.query.contextid;
      axios.get("/api/GetMessage", { params: {id: this.id, contextid: this.contextid}})
        .then(resp => {
          this.wait = null;
          this.doc = resp.data.doc;
          this.loaded = true;
          if (this.id == -1){
            this.caption = this.$lang('newmail');
          };
        })
        .catch(error => {
          this.wait = null;
          this.error = error.message;
          if (error.response.data.message) {
            this.error = error.response.data.message;
          }
        });
    }
  },
  locales: {
    en: {
      mail: "Message",
      newmail: "New Message",
      to: "To:",
      from: "From:",
      subj: "Subject:",
      text: "Text:",
      reply: "Reply",
      save: "Save",
      delete: "Delete",
      send: "Send",
      loading: "Loading...",
      hereFiles: "Click here to add files",
      browse: "Browse",
    },
    de: {
      mail: "Nachricht",
      newmail: "Neue Nachricht",
      to: "An:",
      from: "Von:",
      subj: "Betreff:",
      text: "Text:",
      reply: "Antworten",
      save: "Speichern",
      delete: "Delete",
      send: "Senden",
      loading: "Loading...",
      hereFiles: "Klicken Sie hier, um Dateien hinzuzufügen",
      browse: "Durchsuchen",
    },
    ru:  {
      mail: "Сообщение",
      newmail: "Новое Сообщение",
      to: "Кому:",
      from: "От:",
      subj: "Тема:",
      text: "Текст:",
      reply: "Ответить",
      save: "Сохранить",
      delete: "Удалить",
      send: "Отправить",
      loading: "Загрузка...",
      hereFiles: "Нажмите здесь чтобы добавить файлы",
      browse: "Выбрать",
    },
    pl:  {
      mail: "Wiadomość",
      newmail: "Nowa wiadomość",
      to: "Do:",
      from: "Od:",
      subj: "Temat:",
      text: "Tekst:",
      reply: "Odpowiedź",
      save: "Zapisz",
      delete: "Usuwać",
      send: "Wysłać",
      loading: "Ładowanie...",
      hereFiles: "Kliknij tutaj, aby dodać pliki",
      browse: "Wybierać",
    }
  },
};

</script>

<style>
.fileicon{
  padding: 5px;
  height: 90px;
  width: 90px;
}
.roeditr{
  min-height: 150px;
  padding: 12px 8px 16px 8px;
  line-height: 1.33;
  font-family: inherit;
  color: inherit;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  width: 100%;
  max-height: 700px;
}
.toolbar {
  padding: 0 0 10px 0;
  display: flex;
  justify-content: flex-end;
}

</style>


// WEBPACK FOOTER //
// src/MailItem.vue